<div
  class="position-relative d-flex flex-column align-items-center justify-content-center my-auto p-3"
>
  @if (!isUserLoggedIn()) {
    <img
      class="position-relative z-1 tangoe-logo-error-page"
      src="./assets/images/tangoe_logo.png"
      alt="{{ 'tangoe_logo' | translate }}"
    />
  }
  <h2 class="position-relative z-1 text-center text-nowrap mb-3">{{ title }}</h2>

  <p class="position-relative z-1 w-auto d-inline-block text-center error-text">
    {{ main }}<br />
    {{ main2 }}
  </p>
  @if (hint) {
    <p class="position-relative z-1 w-auto d-inline-block text-center mt-2 error-text">
      {{ hint }}
    </p>
  }

  @if (showReturnToDashboardButton()) {
    <button class="position-relative z-1 btn btn-primary mt-3" (click)="navigateToDashboard()">
      <span>
        {{ 'return_to_dashboard' | translate }}
      </span>
    </button>
  }

  @if (showNavigateToLoginPageButton()) {
    <button class="position-relative z-1 btn btn-primary mt-3" (click)="navigateToLogin()">
      <span>
        {{ 'return_to_login' | translate }}
      </span>
    </button>
  }
  @if (error_code !== undefined) {
    <span class="position-absolute z-0 top-50 start-50 translate-middle error-code">
      {{ error_code }}
    </span>
  }
</div>
